import { environment } from '@core/environment';
import { GrpcRestFetchTransport, RpcRestError, useAuth0Interceptor } from '@deepup/api-utils';
import { scanCategoryClientApiV1 as scanCategoryClientApi } from '@deepup/apis';
import { useMemo } from 'react';

const DEFAULT_ERROR_MESSAGE = 'Failed to fetch scan category';

export const useScanCategory = () => {
  const authInterceptor = useAuth0Interceptor();

  const acceptLanguageInterceptor: typeof authInterceptor = useMemo(
    () => ({
      interceptUnary: (next, method, input, options) => {
        const headers = options.meta ?? {};
        headers['Accept-Language'] = 'en';
        return next(method, input, { ...options, meta: headers });
      },
    }),
    [],
  );

  const client = useMemo(() => {
    const transportRest = new GrpcRestFetchTransport({
      baseUrl: environment.unifiedApiUrl,
      fetchInit: {
        credentials: 'include',
      },
      interceptors: [authInterceptor, acceptLanguageInterceptor],
    });

    return new scanCategoryClientApi.ScanCategoryServiceClient(transportRest);
  }, [authInterceptor, acceptLanguageInterceptor]);

  const getScanCategory = async (categoryId: string) => {
    try {
      const response = await client.getScanCategory({
        id: categoryId,
        version: BigInt(1),
      }).response;
      return response;
    } catch (err) {
      if (err instanceof RpcRestError) {
        throw new Error(err.body && err.body.message ? err.body.message : DEFAULT_ERROR_MESSAGE);
      } else {
        throw new Error(DEFAULT_ERROR_MESSAGE);
      }
    }
  };

  return { getScanCategory };
};
